import type { TagColor } from '@atlaskit/tag';

import { PluginName } from './plugin-name';

export const PLUGIN_TAG_COLOR: Record<PluginName, TagColor> = {
	[PluginName.SEARCH]: 'green',
	[PluginName.PEOPLE]: 'blue',
	[PluginName.TEAMWORK]: 'purple',
	[PluginName.PAGE_SEARCH_PLUGIN]: 'yellow',
};

/**
 * Default tag color for unknown plugins.
 */
export const DEFAULT_PLUGIN_TAG_COLOR: TagColor = 'gray';
